import { useState, useEffect, useCallback } from 'react';
import { Link, useModel, history} from 'umi';
import './Header.css';

import { notification, Button, Modal, message } from 'antd';
import { LoadingOutlined, LogoutOutlined  } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export default function Header()
{  
    const { config, configLoading } = useModel('global');   


  
    return (
        <header className="flex-wrap">
            <div className="left">
                <Link to="/">
                    <picture>
                        <source media="(max-width:600px)" srcset={config?.logo550}></source>
                        <img src={config?.logo} alt={config?.name} />
                    </picture>
                </Link>               
            </div>
            <div className="right">
                {config?.contacts?.map(c => <div className="e">
                    {c.value?.map(p => <a href={"tel:" + p.replace(/[^\d+]/g, '')}>{p}</a>)}
                    <div className="extra">{c.extra}</div>
                </div>)}      
            </div>         
        </header>
    );
}
